// src/components/Layout.jsx
import Navbar from './Navbar';

function Layout({ children }) {
  return (
    <div className="app-container">
      <Navbar />
      <main className="content">
        {children}
      </main>
    </div>
  );
}

export default Layout;